import { type FC } from "react";
import { Check } from "lucide-react";

interface PasswordRequirementProps {
  met: boolean;
  text: string;
}

export const PasswordRequirement: FC<PasswordRequirementProps> = ({ met, text }) => {
  return (
    <div className="flex items-center gap-3">
      <Check className={`h-4 w-4 ${met ? "text-green-600" : "text-stone-300"}`} strokeWidth={3} />
      <span className={`text-sm ${met ? "text-primary" : "text-tertiary"}`}>{text}</span>
    </div>
  );
};
